module.exports = __webpack_public_path__ + "static/martin-f0eb0c9817580c61dab92e4496e261cc.mp4";